// @flow

import { getJSON } from 'redux-api-middleware';
import { I18n } from '@shopify/react-i18n';
import { processRes } from 'src/helpers/actions-helper';

import apiService from 'src/services/api-service';
import {
  GET_CHECKLIST_REQUEST,
  GET_CHECKLIST_SUCCESS,
  GET_CHECKLIST_FAILURE,
  SELECT_CHECKLIST_REQUEST,
  SELECT_CHECKLIST_SUCCESS,
  SELECT_CHECKLIST_FAILURE,
  SKIP_ACTION_ON_CHECKLIST_REQUEST,
  SKIP_ACTION_ON_CHECKLIST_SUCCESS,
  SKIP_ACTION_ON_CHECKLIST_FAILURE,
  TRACK_EVENT_REQUEST,
  TRACK_EVENT_SUCCESS,
  TRACK_EVENT_FAILURE
} from 'stores/flow-type/dashboard/checklist.type';

/**
 * call to get dashboard checklist block api
 * @return {object} The RSAA object for API middleware
 */
export const getChecklist = (i18n: I18n) => {
  return apiService.sendRequest('admin-v3.dashboard-checklist.get-checklist', {}, [
    GET_CHECKLIST_REQUEST,
    {
      type: GET_CHECKLIST_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: GET_CHECKLIST_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Dashboard.Actions.getChecklist'),
          i18n
        )
    }
  ]);
};

/**
 * call to select dashboard checklist block api with checklist 3
 * @return {object} The RSAA object for API middleware
 */
export const selectChecklist = (id, i18n: I18n) => {
  const body = { name: id };
  return apiService.sendRequest('admin-v3.dashboard-checklist.select-checklist', { body }, [
    SELECT_CHECKLIST_REQUEST,
    {
      type: SELECT_CHECKLIST_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { data };
      }
    },
    {
      type: SELECT_CHECKLIST_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Dashboard.Actions.selectChecklist'),
          i18n
        )
    }
  ]);
};
/**
 * call to skip action checklist in dashboard checklist block api
 * @return {object} The RSAA object for API middleware
 */
export const skipAction = (i18n: I18n) => {
  const body = {
    eventSource: 'onboarding',
    eventName: 'skip'
  };
  return apiService.sendRequest('admin-v3.dashboard-checklist.track-event', { body }, [
    SKIP_ACTION_ON_CHECKLIST_REQUEST,
    {
      type: SKIP_ACTION_ON_CHECKLIST_SUCCESS,
      payload: async (action, state, res) => {
        const data = await getJSON(res);

        return { blocks: data };
      }
    },
    {
      type: SKIP_ACTION_ON_CHECKLIST_FAILURE,
      payload: async (action, state, res) =>
        await processRes(
          res,
          'error',
          i18n.translate('AdminHTML.Dashboard.Actions.skipAction'),
          i18n
        )
    }
  ]);
};

/**
 * call to track event checklist in dashboard checklist block api
 * @return {object} The RSAA object for API middleware
 */
export const trackEvent = (eventSource, eventName, label) => {
  const body = {
    eventSource,
    eventName,
    label,
    clickedAt: Date.now()
  };

  //This action does not return any value
  return apiService.sendRequest('admin-v3.dashboard-checklist.track-event', { body }, [
    TRACK_EVENT_REQUEST,
    {
      type: TRACK_EVENT_SUCCESS,
      payload: async () => {
        return {};
      }
    },
    {
      type: TRACK_EVENT_FAILURE,
      payload: async () => {
        return {};
      }
    }
  ]);
};
